import { Filter } from '../types/filter';
import { isValuelessOperator } from './builder-operators.function';
import { FilterOperator } from '../types/filter-operators';

/**
 * Drops field filters whose value is still missing/empty (builder rows the user
 * never completed) and collapses groups accordingly. Never throws.
 */
export function pruneIncompleteFilter<T extends object>(
  filter: Filter<T> | null
): Filter<T> | null {
  if (!filter) return null;
  if (filter.type === 'conditions') {
    const filters = filter.filters
      .map((o) => pruneIncompleteFilter(o))
      .filter((o): o is Filter<T> => o !== null);
    if (filters.length === 0) return null;
    if (filters.length === 1) return filters[0];
    return { ...filter, filters };
  }
  return isCompleteCondition(filter) ? filter : null;
}

function isCompleteCondition<T extends object>(filter: Filter<T>): boolean {
  if (isValuelessOperator((filter as { operator: FilterOperator }).operator)) return true;
  const value = (filter as { value?: unknown }).value;
  if (value === null || value === undefined || value === '') return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object' && 'from' in (value as object)) {
    const range = value as { from: unknown; to: unknown };
    return range.from != null && range.to != null;
  }
  return true;
}
